import React, { Component } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import moment, { relativeTimeRounding } from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import filterIcon from '../css/dark/img/filter.svg';
import 'bootstrap-daterangepicker/daterangepicker.css';
import $ from 'jquery';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import Search_Icon from '../../components/css/dark/img/theme-images/search.svg';
import List from '../List';
import Column_Pie from '../Column_Pie';
import Claim from '../CompanyOverviewClaim';
import ColorJson from '../../../src/whitelabel.json';

class CompanyOverview extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 7);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }

        try {
            this.state = {
                WidgetList: [],
                startDate: new moment(startdate).format("MM/DD/YYYY"),
                endDate: new moment(enddate).format("MM/DD/YYYY"),
                AnalyticData: [],
                userdata: JSON.parse(localStorage.getItem('user')),
                scrollArray: {},
                graphData: [],
                AnalyticList: [],
                SearchDispay: [],
                wholesalerId: '-1'
            };
        }
        catch (error) { }
        this.handleCalendar = this.handleCalendar.bind(this);
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
            });
            $(".dashboard-container").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                $('body').toggleClass('sub-menu-active');
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".dashboard-container").animate({
                marginLeft: -170 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    componentDidMount() {
        $('.readonly-attr').attr('readonly', 'readonly');
        this.setState({ AnalyticList: JSON.parse(localStorage.getItem('analytics_data')) });
        this.changeData();
        $('body').addClass('analyticPage');

        // Top menu search 
        $(document).click(function (event) {
            event.stopPropagation();
            $('#myInputautocomplete-list').slideUp();
        });
        $("#myInput").focus(function () {
            $('.searchSection').addClass('active');
        });
        $("#myInput").focusout(function () {
            $('.searchSection').removeClass('active');
        });
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
    }
    componentWillUnmount() {
        $('body').removeClass('analyticPage');
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        this.changeData(true, changedStartDate, changedEndDate);
        try {
            $('.first-one .form-control').val(changedStartDate);
            $('.second-one .form-control').val(changedEndDate);
        }
        catch (error) {
        }
    }
    handlechangea(e) {
        this.RepeatCode();
    }
    changeData(dateChanged, stdate, endate, wholesalerId = '-1') {
        var wname = '';
        var startDateObj = '';
        var endDateObj = '';
        if (dateChanged == undefined) {
            startDateObj = this.state.startDate;
            endDateObj = this.state.endDate;
        }
        else {
            startDateObj = stdate;
            endDateObj = endate;
        }
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        let changedStartDate = new moment(startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(endDate).format("MM/DD/YYYY");
        this.setState({ startDate: changedStartDate, endDate: changedEndDate });
        var APIBaseURL = "";
        var AdFilterJson = '';
        AdFilterJson = JSON.parse(localStorage.getItem('Overview_Filter'));
        APIBaseURL = '/api/ComOverview';
        var Widget1 = "";
        var Widget2 = "";
        var Widget3 = "";
        Widget1 = "{\"wname\"" + ":\"" + "" + "\",\"whname\"" + ":\"" + "" + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"chart_type\"" + ":\"" + "list\"" + ",\"rcount\"" + ":" + 30 + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        Widget2 = "{\"wname\"" + ":\"" + "" + "\",\"whname\"" + ":\"" + "" + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"chart_type\"" + ":\"" + "list\"" + ",\"rcount\"" + ":" + 30 + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        Widget3 = "{\"wname\"" + ":\"" + "" + "\",\"whname\"" + ":\"" + "" + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"chart_type\"" + ":\"" + "list\"" + ",\"rcount\"" + ":" + 30 + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var Day_Supply_30_90_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var Member_Age_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var primaryColor;
        var secondaryColor;
        var extraColor;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            extraColor = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
            extraColor = ColorJson.ApplicationColor.Glic_extra_color;
        }
        this.setState({
            dashboardName: wname,
            graphData: [
                {
                    url: APIBaseURL + "/Number_Statistics",
                    type: "Claim",
                    title: "",
                    Subtitle: "",
                    ColorCode: extraColor,
                    id: "RxSensClaim",
                    RequestJson: Widget3,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/state_wise_paid_claims",
                    type: "List",
                    title: 'Paid Claims by State',
                    Subtitle: 'Total paid claims broken down by state',
                    ColorCode: secondaryColor,
                    DataType: "NA",
                    XlabelString: "",
                    YlabelString: "",
                    id: "ComOverview_widget1",
                    RequestJson: Widget1,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/pharmacy_chain_paid_claims",
                    type: "List",
                    title: 'Paid Claims (%) by Pharmacy Chain',
                    Subtitle: 'Paid claims % broken down by Pharmacy Chain',
                    ColorCode: secondaryColor,
                    DataType: "NA",
                    XlabelString: "",
                    YlabelString: "",
                    id: "ComOverview_pharmacy_chain_paid_claims",
                    RequestJson: Widget1,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/drug_wise_high_savings",
                    type: "List",
                    title: 'Highest Script Savings',
                    Subtitle: 'Top 10 prescriptions with the highest savings',
                    ColorCode: secondaryColor,
                    DataType: "NA",
                    XlabelString: "",
                    YlabelString: "",
                    id: "ComOverview_widget2",
                    RequestJson: Widget2,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/day_supply_30_90",
                    type: "Column_Pie",
                    title: "30/90 Day Supply",
                    Subtitle: "% of prescription days supply",
                    XlabelString: "",
                    YlabelString: "",
                    ColorCode: "#ffba10",
                    id: "Day_Supply_30_90",
                    RequestJson: Day_Supply_30_90_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                },
                {
                    url: APIBaseURL + "/member_age",
                    type: "Column_Pie",
                    title: "Member Age",
                    Subtitle: "Age of Members filling prescriptions",
                    XlabelString: "",
                    YlabelString: "",
                    ColorCode: "#ffba10",
                    id: "Member_Age",
                    RequestJson: Member_Age_RequestJson,
                    RequestJson1: JSON.stringify(AdFilterJson)
                }
            ]
        });
    }
    HandleSearchKeyUp = e => {
        try {
            let searchText = $('#myInput').val();
            let authData = this.state.userdata["authdata"];
            if (searchText.length >= 2) {
                this.GetSearchDataList(authData, searchText);
            }
            else {
                this.setState({ SearchDispay: null });
            }
        }
        catch (error) {
        }
    }
    HandleSearchFocus = e => {
        try {
            if ($('#myInput').val().length == 0) {
                this.setState({ SearchDispay: null });
            }
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    GetSearchDataList(UserName, Stext) {
        $('#myInputautocomplete-list').css('display', 'block');
        try {
            userService.CompnayOverViewSearch(UserName, Stext).then(
                apidata => {
                    try {
                        this.setState({ SearchDispay: apidata });
                    }
                    catch (error) {
                        this.setState({ SearchDispay: null });
                    }
                }
            );
        }
        catch (error) { }
    }
    RepeatCode = (e) => {
        try {
            var startdate = new Date();
            startdate.setDate(startdate.getDate() - 30);
            var enddate = new Date();
            if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
                startdate = localStorage.getItem('User_Start_Date');
            }
            if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
                enddate = localStorage.getItem('User_End_Date');
            }
            startdate = new moment(startdate).format("MM/DD/YYYY");
            enddate = new moment(enddate).format("MM/DD/YYYY");
            localStorage.setItem('Filter_Last_Update_Time', new Date());
            this.changeData(true, startdate, enddate, '-1');
        }
        catch (error) { }
    }
    HandleSearchItemClick = e => {
        $('#myInput').val('');
        $('#myInputautocomplete-list').css('display', 'none');
        this.setState({ SearchDispay: [] });
        var nodevalue = $(e.target).attr('nodename');
        var nodetype = $(e.target).attr('nodetype');
        var nodeUid = $(e.target).attr('nodeUid');
        try {
            this.Create_Advance_FIlter_Json(nodetype, nodevalue, nodeUid);
        }
        catch (error) { }
        try {
            var startdate = new Date();
            startdate.setDate(startdate.getDate() - 30);
            var enddate = new Date();
            if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
                startdate = localStorage.getItem('User_Start_Date');
            }
            if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
                enddate = localStorage.getItem('User_End_Date');
            }
            startdate = new moment(startdate).format("MM/DD/YYYY");
            enddate = new moment(enddate).format("MM/DD/YYYY");
            this.changeData(true, startdate, enddate, $(e.target).attr('nodevalue'));
        }
        catch (error) { }
    }
    Create_Advance_FIlter_Json(nodetype, nodevalue, nodeUid) {
        var Created_Advance_Filter = JSON.parse(localStorage.getItem('Overview_Filter'));
        var arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter != '' && Created_Advance_Filter != undefined && Created_Advance_Filter != "null" && Created_Advance_Filter != "{}") {
            var IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }))
            for (var ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name == nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].map((e1, i1) => {
                        if (e1.toLowerCase() == nodevalue.toLowerCase()) {
                            checkavail = checkavail + 1;
                        }
                    });
                    if (checkavail == 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Overview_Filter', JSON.stringify(Created_Advance_Filter));
                        let newDate = new Date();
                        localStorage.setItem('An_Overview_Last_Update_Time', newDate);
                        localStorage.setItem('An_Updated_AdOverview_Status', JSON.stringify(Created_Advance_Filter));
                        this.handlechangea();
                    }
                    break;
                }
                else {
                    continue;
                }
            }
            if (IsMatched == false) {
                try {
                    var JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Overview_Filter', TempJson);
                    let newDate = new Date();
                    localStorage.setItem('An_Overview_Last_Update_Time', newDate);
                    localStorage.setItem('An_Updated_AdOverview_Status', TempJson);
                    this.handlechangea();
                }
                catch (error) {
                }
            }
        }
        else {
            var JsonData = '';
            var JsonData_New = '';
            try {
                JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                JsonData_New = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData_New = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData_New + '}}';
                localStorage.setItem('Overview_Filter', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                let newDate = new Date();
                localStorage.setItem('An_Overview_Last_Update_Time', newDate);
                localStorage.setItem('An_Updated_AdOverview_Status', JSON.stringify(Created_Advance_Filter));
                this.handlechangea();
            }
            catch (error) {
            }
        }
    }
    GetTagTypeFullName(stext) {
        try {
            if (stext == 'Pharmacy Chain') {
                return 'Pharmacy Chain'
            }
            else if (stext == 'Wholesaler Name') {
                return 'Wholesaler Name'
            }
            else {
                return 'Unknown'
            }
        }
        catch (error) {
        }
    }
    HandleRemoveTag = e => {
        try {
            let dnodename = $(e.target).parent().attr('nodename');
            let dnodeval = $(e.target).parent().attr('nodevalue');
            try {
                let ExistJson = JSON.parse(localStorage.getItem('Overview_Filter'));
                let ItemIndex = ExistJson[dnodename].indexOf(dnodeval);
                if (ItemIndex > -1) {
                    ExistJson[dnodename].splice(ItemIndex, 1);
                    if (ExistJson[dnodename].length == 0) {
                        delete ExistJson[dnodename]
                    }
                }
                try {
                    if (JSON.stringify(ExistJson) == "{}") {
                        localStorage.setItem('Overview_Filter', null);
                    }
                    else {
                        localStorage.setItem('Overview_Filter', JSON.stringify(ExistJson));
                    }
                }
                catch (error) {
                }
                this.RepeatCode();
            }
            catch (error) {
            }
        } catch (error) {
        }
    }
    HandleResetButton = e => {
        try {
            $("span." + "filtered_tag_dashboard").hide();
            $('button[class="reset-btn"]').css('display', 'none');
            this.setState({ loading: false });
            localStorage.setItem('Overview_Filter', null);
            this.RepeatCode();
        }
        catch (error) {
        }
    }
    render() {
        let LocalAnayticFilterJson = '';
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
            LocalAnayticFilterJson = JSON.parse(localStorage.getItem('Overview_Filter'));
        } catch (error) { }
        return (
            <div className="anylytics admin company-overview">
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="dashboard-content-parent">
                    <div className="newBoard">
                        <div className="parent">
                            <div className="contentContainer">
                                <div>
                                    <div className='row'>
                                        <div className='double-column'>
                                            <div className="dashboard-container analytics" id="dashboard-container">

                                                <h2 className="dashboardHeading">Company Overview (RXS only)<span className="beta-link"><span className="beta">Beta</span></span></h2>

                                                <div id="dashboard_header_inner" className="admin-login">
                                                    <div id="dashboard_header_select">
                                                        <DateRangePicker 
                                                            popperModifiers={{ preventOverflow: { enabled: true, }, }} 
                                                            initialSettings={{
                                                                startDate: this.state.startDate,
                                                                endDate: this.state.endDate,
                                                                maxDate: moment().toDate(),
                                                                locale: {
                                                                    format: 'MM/DD/YYYY'
                                                                }
                                                            }}
                                                            onApply={this.handleCalendar}
                                                        >
                                                            <div className="react-bootstrap-daterangepicker-container">
                                                                <div className="react-datepicker_input-container first-one">
                                                                    <input type="text" className="form-control first readonly-attr" value={this.state.startDate} />
                                                                </div>
                                                                <div className="react-datepicker_input-container second-one">
                                                                    <input type="text" className="form-control readonly-attr" value={this.state.endDate} />
                                                                </div>
                                                            </div>
                                                        </DateRangePicker>
                                                        <div className='searchSection'>
                                                            <img className="SearchIcon" src={Search_Icon} alt="" />

                                                            <form autoComplete="off">
                                                                <div className="autocomplete">
                                                                    <input id="myInput" type="text" name="myCountry" placeholder="Search for a Wholesaler or Pharmacy Chain" className="form-control searchFilter" onFocus={this.HandleSearchFocus} onKeyUp={this.HandleSearchKeyUp} />
                                                                    {
                                                                        this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                                                            <div id="myInputautocomplete-list" className="autocomplete-items">
                                                                                {
                                                                                    this.state.SearchDispay.map((item, index) => {
                                                                                        return (<div className="searchitempopulate" nodetype={item.typeName} nodename={item.o_name} nodeUid={item.uid} onClick={this.HandleSearchItemClick}>{item.typeName}
                                                                                            <span nodename={item.o_name} nodetype={item.typeName} nodeUid={item.uid}>{item.o_name}</span>
                                                                                        </div>
                                                                                        )
                                                                                    })}
                                                                            </div> : null : null
                                                                    }
                                                                </div>
                                                            </form>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clear"></div>

                                                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                                                {
                                                    LocalAnayticFilterJson != null && LocalAnayticFilterJson.propertyIsEnumerable.length > 0 ?
                                                        <div className='filtered_tag_selected tag-available anlytical-tag'>
                                                            {
                                                                <div className="filtered_content">
                                                                    <div className="filtered_adjust">
                                                                        {
                                                                            Object.keys(LocalAnayticFilterJson).map((key, index) => {
                                                                                return (
                                                                                    LocalAnayticFilterJson[key].map((e1, i1) => {
                                                                                        return (
                                                                                            <span id={key.replace(' ', '') + e1.replace(' ', '')} className='filtered_tag_dashboard' nodename={key} nodevalue={e1} nodevalueid={e1}>{this.GetTagTypeFullName(key) + '-' + e1}<label onClick={this.HandleRemoveTag}></label></span>
                                                                                        )
                                                                                    })
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                    <button className="reset-btn" onClick={this.HandleResetButton}>Reset</button>
                                                                </div>
                                                            }
                                                        </div>
                                                        :
                                                        <div className='filtered_tag_selected anlytical-tag'>
                                                            {
                                                                <div className="filtered_content">
                                                                    <div className="filtered_adjust">
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                }
                                                {
                                                    this.state.graphData.map((item, index, id) => {
                                                        var k = null;
                                                        return (
                                                            <div id={item.id + index} className={`${item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third"}${item.id == "ComOverview_widget1" ? ' full-layout list' : ''}${item.id == "ComOverview_widget2" ? ' full-layout list' : ''}${item.id == "RxSensClaim" ? ' full-layout' : ''}${item.id == "ComOverview_pharmacy_chain_paid_claims" ? ' full-layout list' : ''}${item.id == "Day_Supply_30_90" ? ' barlist left-margin' : ''}${item.id == "Member_Age" ? ' barlist left-margin' : ''}`} key={"graph-widget" + index}>
                                                                <div className="widget-content" key={"graph-widget-content" + index}>
                                                                    <div className="custom-scroll">
                                                                        {
                                                                            <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                                {item.type == "List" ? <List data={item} key={"listgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                {item.type == "Claim" ? <Claim data={item} key={"claimbox" + index} _Index={index} /> : null}
                                                                                {item.type == "Column_Pie" ? <Column_Pie data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={this.handeChangefilter} /> : null}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="widget-foot">
                                                                    &nbsp;
                                                                            </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <div className="sortby">
                                                    <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Calendar</a>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CompanyOverview;